import { create } from 'zustand';

import { driveKey, type DriveNote } from '../confirm/drive';
import { useSettings } from '../store/settings';

/**
 * Лимит из купона конторы — потолок ноги до перезагрузки вкладки. Отдельная
 * карта, не баланс: в профиль и в кассу он не пишется, баланс не поднимает.
 */
export function capFromCoupon(one: DriveNote): void {
  if (one.maxStake === undefined) return;
  const value = Number(one.maxStake);
  if (!(value > 0)) return;
  const couponCaps = useSettings.getState().couponCaps;
  if (couponCaps[one.venue] === value) return;
  useSettings.setState({ couponCaps: { ...couponCaps, [one.venue]: value } });
}

interface DriveStore {
  byVenue: Record<string, DriveNote>;
  byIntent: Record<string, DriveNote>;
  note: (one: DriveNote) => void;
  of: (venue: string) => DriveNote | null;
}

export const useDrive = create<DriveStore>((set, get) => ({
  byVenue: {},
  byIntent: {},
  note: (one) => set((state) => {
    const key = driveKey(one.venue, one.url);
    if ((state.byIntent[key]?.at ?? 0) > one.at) return state;
    const entries = Object.entries(state.byIntent)
      .filter(([k, note]) => k !== key && Date.now() - note.at < 180_000).slice(-255);
    return {
      byVenue: { ...state.byVenue, [one.venue]: one },
      byIntent: { ...Object.fromEntries(entries), [key]: one },
    };
  }),
  of: (venue) => get().byVenue[venue] ?? null,
}));

useDrive.subscribe((state, prev) => {
  if (state.byIntent === prev.byIntent) return;
  for (const one of Object.values(state.byIntent)) {
    if (prev.byIntent[driveKey(one.venue, one.url)] !== one) capFromCoupon(one);
  }
});
